import { History, createBrowserHistory, BrowserHistoryOptions, To, Location } from '@remix-run/router';

export const preserveQueryParameters = (
  history: History,
  preserve: string[],
  location: Partial<Location>,
): Partial<Location> => {
  if (history.location.search) {
    const queryParams = new URLSearchParams(history.location.search);
    const preservedQuery = new URLSearchParams();
    for (const p of preserve) {
      const value = queryParams.get(p);
      if (value !== undefined && value !== null) {
        preservedQuery.set(p, value);
      }
    }
    if (location.search) {
      const params = new URLSearchParams(location.search);
      params.forEach(function (value, key) {
        if (value === '' && preservedQuery.has(key)) {
          preservedQuery.delete(key);
        } else {
          preservedQuery.set(key, value);
        }
      });
    }
    location.search = `?${preservedQuery.toString()}`;
  }
  return location;
};

const createLocationDescriptorObject = (location: To, state?: any): Partial<Location> => {
  return typeof location === 'string' ? { pathname: location, state } : location;
};

export interface CreateHistoryOptions extends BrowserHistoryOptions {
  preserve: string[];
}

export const createHistory = ({ preserve, ...options }: CreateHistoryOptions): History => {
  const history = createBrowserHistory(options);
  const oldPush = history.push;
  const oldReplace = history.replace;
  history.push = (path: To, state?: any) => {
    oldPush.apply(history, [
      preserveQueryParameters(history, preserve, createLocationDescriptorObject(path, state)),
      state,
    ]);
  };

  history.replace = (path: To, state?: any) => {
    oldReplace.apply(history, [
      preserveQueryParameters(history, preserve, createLocationDescriptorObject(path, state)),
      state,
    ]);
  };
  return history;
};
